// app locale data
let zhJson = {
    // 公共
    "sys": require('./zh-CN/sys.json'),
    // 控制台
    "console": require('./zh-CN/console.json'),
    // 订单
    "order": require('./zh-CN/order.json'),
    // 用户
    "user": require('./zh-CN/user.json'),

}

let enJson = {
    // 公共
    "sys": require('./en-US/sys.json'),
    // 控制台
    "console": require('./en-US/console.json'),
    // 订单
    "order": require('./en-US/order.json'),
    // 用户
    "user": require('./en-US/user.json'),

}

const I18n = {
    "en-US": enJson,
    "zh-CN": zhJson,
    "zh": zhJson,
}

export default I18n
